$( document ).ready(function() {
    $(document).on('submit','.component-Products-BuyForm form',function (e) {
        e.preventDefault();
        var documentWidth = $(document).width();

        //Display Breakpoints
        //$md: 992px;
        if(window.matchMedia('(min-width: 993px)').matches) {
            // animace
            var object = $("<div>", {
                "class": "basketaddanim"
            });
            $("body").append(object);
            object.css("top", $(this).offset().top - $(window).scrollTop());
            object.css("left", $(this).offset().left);

            documentWidth = $(window).width();

            if(documentWidth > 1140){
                documentWidth = 1140;
            }

            var leftPos = $(".dropdown-menu__basket-icon-container").offset().left;

            if(window.scrollY > 120) //od 120px se z basketu stava css basket moving (position:fixed)
            {
                topPxFirstAnimation = 0;
                topPxBasket = 30;
            }else {
                topPxBasket = 68; //umisteni kosiku - pocet px od vrchu stranky pri vyscrollovani nahoru
                topScroll = window.scrollY;
                topPxBasket = topPxBasket - topScroll;
                topPxFirstAnimation = topPxBasket - 15;
            }

            $(object).animate({
                top: topPxFirstAnimation,
                left: leftPos - 15,
            }, 900, "swing", function(){
                $(object).animate({
                    top: topPxBasket,
                    left: leftPos,
                }, 200, "swing", function(_this){
                    $(object).remove();
                });
            });

            $(window).scroll();

            window.setTimeout(function () {
                object.addClass("basketaddanimsmile")
            }, 400);
        }

    });

    $(window).scroll(function () {

       if(window.pageYOffset > 120) $('#component-Models-TaxDocuments-Basket-1 .dropdown-menu').first().addClass('moving');
       else $('#component-Models-TaxDocuments-Basket-1 .dropdown-menu').first().removeClass('moving');
       if($('#component-Models-TaxDocuments-Basket-1 .modal-menu').first().data('Modal')) $('#component-Models-TaxDocuments-Basket-1 .modal-menu').first().data('Modal').recalculatePosition();
    });
    $(window).scroll();
});
